import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown
} from 'semantic-ui-react'

const CardAddOrderSetTemplateUX = (props: any) => {
    return(
      <div
        className="ui form"
        style={{ width: "100%", height: "75vh"}}>
        <div
          id="CardAddOrderSetTemplateUX-div-1"
          style={{ padding: "0px 15px" }}>
          
          <Form
            id="CardAddOrderSetTemplateUX-Form-5">
            <FormGroup
              className="--override-disabled --grey"
              id="CardAddOrderSetTemplateUX-FormGroup-6"
              inline={true}>
              <FormField
                id="CardAddOrderSetTemplateUX-FormField-7">
                <label
                  id="CardAddOrderSetTemplateUX-label-11">
                  แผนก
                </label>
              </FormField>
              <FormField
                id="CardAddOrderSetTemplateUX-FormField-8">
                <div
                  id="CardAddOrderSetTemplateUX-div-13">
                  
                  <Input
                    disabled={true}
                    id="CardAddOrderSetTemplateUX-Input-15"
                    value={props.divisionName}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardAddOrderSetTemplateUX-FormField-9">
                <label
                  id="CardAddOrderSetTemplateUX-label-12">
                  แพทย์
                </label>
              </FormField>
              <FormField
                id="CardAddOrderSetTemplateUX-FormField-10">
                <div
                  id="CardAddOrderSetTemplateUX-div-14">
                  
                  <Input
                    disabled={true}
                    id="CardAddOrderSetTemplateUX-Input-16"
                    value={props.doctorName}>
                  </Input>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardAddOrderSetTemplateUX-div-2"
          style={{display: "flex", width: "100%", height: "70vh"}}>
          
          <div
            id="CardAddOrderSetTemplateUX-div-3"
            style={{ width: "25%", padding: "5px", borderRight: "2px solid rgb(204, 204, 204)" }}>
            
            <Form
              id="CardAddOrderSetTemplateUX-Form-17">
              <FormGroup
                id="CardAddOrderSetTemplateUX-FormGroup-18">
                <FormField
                  id="CardAddOrderSetTemplateUX-FormField-22">
                  <label
                    id="CardAddOrderSetTemplateUX-label-29"
                    style={{ fontWeight: "bold", fontSize: "18px" }}>
                    เลือก Template
                  </label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardAddOrderSetTemplateUX-FormGroup-19"
                inline={true}>
                <FormField
                  id="CardAddOrderSetTemplateUX-FormField-24"
                  width="6">
                  <label
                    id="CardAddOrderSetTemplateUX-label-30">
                    ประเภทชุดคำสั่ง
                  </label>
                </FormField>
                <FormField
                  id="CardAddOrderSetTemplateUX-FormField-25"
                  width={10}>
                  <div
                    id="CardAddOrderSetTemplateUX-div-34"
                    style={{ width: "100%" }}>
                    
                    <Dropdown
                      fluid={true}
                      id="CardAddOrderSetTemplateUX-Dropdown-35"
                      name="type"
                      onChange={props.onChangeSearchData}
                      options={props.typeOrderOption}
                      selection={true}
                      value={props.searchTemplate?.type}>
                    </Dropdown>
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardAddOrderSetTemplateUX-FormGroup-20"
                inline={true}>
                <FormField
                  id="CardAddOrderSetTemplateUX-FormField-26"
                  width={12}>
                  <Input
                    icon="search"
                    id="CardAddOrderSetTemplateUX-Input-37"
                    name="name"
                    onChange={props.onChangeSearchData}
                    placeholder="ชื่อชุดคำสั่ง"
                    value={props.searchTemplate?.name}>
                  </Input>
                </FormField>
                <FormField
                  id="CardAddOrderSetTemplateUX-FormField-27"
                  width={4}>
                  <div
                    id="CardAddOrderSetTemplateUX-div-31">
                    {props.buttonSearchTemplate}
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardAddOrderSetTemplateUX-FormGroup-21"
                style={{ width: "100%"}}>
                <FormField
                  id="CardAddOrderSetTemplateUX-FormField-28"
                  inline={true}
                  style={{ width: "100%"}}
                  width={16}>
                  <div
                    id="CardAddOrderSetTemplateUX-div-33"
                    style={{ width: "100%"}}>
                    {props.templateList}
                  </div>
                </FormField>
              </FormGroup>
            </Form>
          </div>
          <div
            id="CardAddOrderSetTemplateUX-div-4"
            style={{flex: "3 1 0%", ...(!props.showTemplateDetail && { display: "none"}) }}>
            {}
            <div
              id="CardAddOrderSetTemplateUX-div-42"
              style={{ padding: "0px 5px" }}>
              
              <div
                id="CardAddOrderSetTemplateUX-div-43"
                style={{ ...(!props.showTemplateDetail && { display: "none"}) }}>
                {props.orderDetailList}
              </div>
            </div>
            <div
              id="CardAddOrderSetTemplateUX-div-40"
              style={{ display: "flex", justifyContent: "flex-end", marginTop: "30px", width: "100%", ...(!props.showTemplateDetail && { display: "none"}) }}>
              
              <div
                id="CardAddOrderSetTemplateUX-div-41">
                {props.buttonComfrimOrder}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardAddOrderSetTemplateUX

export const screenPropsDefault = {"cardSelectTemplate":"[CardSelectTemplate]","divisionChoices":{"0":{"key":1,"text":"a","value":1}},"dsbList":{"0":1,"1":2},"mode":"home","selectedChairs":"00023-1, 00024-2","zoneSelector":"[ZoneSelector]"}

/* Date Time : Thu Aug 21 2025 10:10:10 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"75vh\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 15px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width: \"100%\", height: \"70vh\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"25%\", padding: \"5px\", borderRight: \"2px solid rgb(204, 204, 204)\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{flex: \"3 1 0%\", ...(!props.showTemplateDetail && { display: \"none\"}) }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-Form-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-label-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-label-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Input",
      "parent": 13,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-Input-15"
        },
        "value": {
          "type": "code",
          "value": "props.divisionName"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Input",
      "parent": 14,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-Input-16"
        },
        "value": {
          "type": "code",
          "value": "props.doctorName"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Form",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-Form-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormGroup-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormGroup-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormGroup-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormGroup-21"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-22"
        },
        "inline": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-24"
        },
        "width": {
          "type": "value",
          "value": "6"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-25"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-26"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-27"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก Template"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-label-29"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทชุดคำสั่ง"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-label-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearchTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-31"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.templateList"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Dropdown",
      "parent": 34,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-Dropdown-35"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearchData"
        },
        "options": {
          "type": "code",
          "value": "props.typeOrderOption"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchTemplate?.type"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Input",
      "parent": 26,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-Input-37"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearchData"
        },
        "placeholder": {
          "type": "value",
          "value": "ชื่อชุดคำสั่ง"
        },
        "value": {
          "type": "code",
          "value": "props.searchTemplate?.name"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", marginTop: \"30px\", width: \"100%\", ...(!props.showTemplateDetail && { display: \"none\"}) }"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonComfrimOrder"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-41"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 5px\" }"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderDetailList"
        },
        "id": {
          "type": "value",
          "value": "CardAddOrderSetTemplateUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.showTemplateDetail && { display: \"none\"}) }"
        }
      },
      "seq": 43,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardAddOrderSetTemplateUX",
  "project": "cudent2",
  "screenPropsDefault": {
    "cardSelectTemplate": "[CardSelectTemplate]",
    "divisionChoices": {
      "0": {
        "key": 1,
        "text": "a",
        "value": 1
      }
    },
    "dsbList": {
      "0": 1,
      "1": 2
    },
    "mode": "home",
    "selectedChairs": "00023-1, 00024-2",
    "zoneSelector": "[ZoneSelector]"
  },
  "width": 85
}

*********************************************************************************** */
